import './GalleryItem.svelte.css.proxy.js';
/* src/components/GalleryItem.svelte generated by Svelte v3.32.1 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	children,
	claim_element,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "../_snowpack/pkg/svelte/internal.js";

import { onMount } from "../_snowpack/pkg/svelte.js";

function create_fragment(ctx) {
	let div1;
	let div0;
	let a;
	let img;
	let img_src_value;
	let img_id_value;
	let a_href_value;

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			a = element("a");
			img = element("img");
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			a = claim_element(div0_nodes, "A", { href: true });
			var a_nodes = children(a);

			img = claim_element(a_nodes, "IMG", {
				src: true,
				id: true,
				loading: true,
				alt: true,
				class: true
			});

			a_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = /*thumbnail*/ ctx[2])) attr(img, "src", img_src_value);
			attr(img, "id", img_id_value = /*id*/ ctx[1] + "-img");
			attr(img, "loading", "lazy");
			attr(img, "alt", /*title*/ ctx[0]);
			attr(img, "class", "svelte-1a3a9yv");
			attr(a, "href", a_href_value = `/work/${/*id*/ ctx[1]}`);
			attr(div0, "class", "content svelte-1a3a9yv");
			attr(div1, "class", "square svelte-1a3a9yv");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, a);
			append(a, img);
			/*img_binding*/ ctx[4](img);
		},
		p(ctx, [dirty]) {
			if (dirty & /*thumbnail*/ 4 && img.src !== (img_src_value = /*thumbnail*/ ctx[2])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*id*/ 2 && img_id_value !== (img_id_value = /*id*/ ctx[1] + "-img")) {
				attr(img, "id", img_id_value);
			}

			if (dirty & /*title*/ 1) {
				attr(img, "alt", /*title*/ ctx[0]);
			}

			if (dirty & /*id*/ 2 && a_href_value !== (a_href_value = `/work/${/*id*/ ctx[1]}`)) {
				attr(a, "href", a_href_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
			/*img_binding*/ ctx[4](null);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { title = "" } = $$props;
	let { id = "" } = $$props;
	let { thumbnail = "" } = $$props;
	let image;

	function img_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			image = $$value;
			$$invalidate(3, image);
		});
	}

	$$self.$$set = $$props => {
		if ("title" in $$props) $$invalidate(0, title = $$props.title);
		if ("id" in $$props) $$invalidate(1, id = $$props.id);
		if ("thumbnail" in $$props) $$invalidate(2, thumbnail = $$props.thumbnail);
	};

	return [title, id, thumbnail, image, img_binding];
}

class GalleryItem extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { title: 0, id: 1, thumbnail: 2 });
	}
}

export default GalleryItem;
//# sourceMappingURL=GalleryItem.svelte.js.map
